export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? '';
export const REFERENCES_API_URL = `${API_BASE_URL}/api/references`;
export const PARTNER_API_URL = `${API_BASE_URL}/api/partner`; 